import { Ticket, TicketFilteringCriteria } from "../../../../../api-client";
import React, { useEffect } from "react";
import { PIVOTKEYS } from "../../../../../utils/constants";
import TicketsPivot from "../TicketsPivot/tickets-pivot";
import PersonalTicketsPivot from "../PersonalTicketsPivot/personal-tickets-pivot";
import CustomViewTicketsPivot from "../CustomViewTicketsPivot/custom-view-tickets-pivot";

interface IPivotItemContent {
    activeKey: string;
    itemKey: string;
    data?: Ticket[];
    dataLoading?: boolean;
    onApplyCriteria?: (filterCriteria: TicketFilteringCriteria | undefined) => void;
    onClearCriteria?: () => void;
    deleteTicketLoading?: boolean;
    onDeleteTicket?: (id: string, onSuccess: () => void) => void;
    handleTicketsRetrieve?: () => Promise<Ticket[]>;
    onExportTicket?: () => void;
}

const PivotItemContent: React.FunctionComponent<IPivotItemContent> = ({
    activeKey,
    itemKey,
    data,
    dataLoading,
    onApplyCriteria,
    onClearCriteria,
    deleteTicketLoading,
    onDeleteTicket,
    handleTicketsRetrieve,
    onExportTicket
}) => {

    const [dataSource, setDataSource] = React.useState<Ticket[]>([]);

    useEffect(() => {
        if (data) {
            setDataSource(data);
        } else if (handleTicketsRetrieve) {
            if (activeKey === itemKey) {
                handleTicketsRetrieve().then(response => {
                    setDataSource(response)
                });
            }
        }
    }, [data, activeKey]);

    if (itemKey === PIVOTKEYS.ALLTICKETS) {
        return <TicketsPivot
            dataSource={dataSource}
            dataLoading={dataLoading}
            onApplyCriteria={(filterCriteria) => { if (onApplyCriteria) { onApplyCriteria(filterCriteria) } }}
            onClearCriteria={onClearCriteria ?? Function}
            deleteTicketLoading={deleteTicketLoading}
            onDeleteTicket={onDeleteTicket ?? (() => { })}
            onExportTicket={onExportTicket}
        />

    } else if (itemKey === PIVOTKEYS.MYTICKETS) {
        return <PersonalTicketsPivot
            dataSource={dataSource}
            dataLoading={dataLoading}
        />

    } else if (itemKey?.startsWith(PIVOTKEYS.CUSTOMIZED)) {
        return <CustomViewTicketsPivot
            dataSource={dataSource}
            dataLoading={dataLoading}
            deleteTicketLoading={deleteTicketLoading}
            onDeleteTicket={onDeleteTicket ?? (() => { })}
            retrieveCallback={() => {
                if (handleTicketsRetrieve) {
                    handleTicketsRetrieve().then(response => {
                        setDataSource(response)
                    });
                }
            }}
            onExportTicket={onExportTicket}
        />
    } else {
        return null;
    }
};

export default PivotItemContent;